import { IHeSoUuTienTKB } from "../../model/respone/category/IHeSoUuTienTKB";
import { apiClient } from "../apiClient";

export const HE_SO_UU_TIEN_TKB_API = "he-so-uu-tien-tkb";
export const heSoUuTienTKBApi = {
  SelectAll: () => apiClient.get(`${HE_SO_UU_TIEN_TKB_API}`),
  Update: (payload: IHeSoUuTienTKB) => apiClient.put(`${HE_SO_UU_TIEN_TKB_API}`, payload),
};
